import api from './api';

const materialCatalogService = {
  // Listar todos os materiais com filtros
  getAllMaterials: async (params = {}) => {
    try {
      const response = await api.get('/material-catalog', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar materiais:', error);
      throw error;
    }
  },

  // Buscar material por ID
  getMaterialById: async (id) => {
    try {
      const response = await api.get(`/material-catalog/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar material:', error);
      throw error;
    }
  },

  // Criar material
  createMaterial: async (materialData) => {
    try {
      console.log('🟢 [SERVICE] createMaterial chamado');
      console.log('🟢 [SERVICE] materialData enviado:', JSON.stringify(materialData, null, 2));
      const response = await api.post('/material-catalog', materialData);
      console.log('🟢 [SERVICE] Resposta recebida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao criar material:', error);
      throw error;
    }
  },

  // Atualizar material
  updateMaterial: async (id, materialData) => {
    try {
      const response = await api.put(`/material-catalog/${id}`, materialData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar material:', error);
      throw error;
    }
  },

  // Deletar material (soft delete)
  deleteMaterial: async (id) => {
    try {
      const response = await api.delete(`/material-catalog/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar material:', error);
      throw error;
    }
  },

  // Buscar materiais por termo
  searchMaterials: async (params = {}) => {
    try {
      const response = await api.get('/material-catalog/search', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar materiais:', error);
      throw error;
    }
  },

  // Listar materiais por categoria
  getMaterialsByCategory: async (category) => {
    try {
      const response = await api.get(`/material-catalog/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar materiais por categoria:', error);
      throw error;
    }
  },

  // Calcular preço
  calculatePrice: async (params) => {
    try {
      const response = await api.get('/material-catalog/calculate-price', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular preço:', error);
      throw error;
    }
  },

  // Calcular preço (POST)
  calculatePricePost: async (data) => {
    try {
      const response = await api.get('/material-catalog/calculate-price', { params: data });
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular preço:', error);
      throw error;
    }
  },

  // Importar materiais para orçamento de projeto
  importToBudget: async (projectId, materiais) => {
    try {
      console.log('🟢 [SERVICE] importToBudget chamado');
      console.log('🟢 [SERVICE] projectId:', projectId);
      console.log('🟢 [SERVICE] materiais:', JSON.stringify(materiais, null, 2));
      const response = await api.post(`/material-catalog/import-to-budget/${projectId}`, {
        materiais
      });
      console.log('🟢 [SERVICE] Resposta recebida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao importar para orçamento:', error);
      throw error;
    }
  },

  // ==========================================
  // NOVOS MÉTODOS PARA APRESENTAÇÃO
  // ==========================================

  // Listar categorias de materiais
  getCategoriasMateriais: async (params = {}) => {
    try {
      const response = await api.get('/material-catalog/categorias-materiais', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar categorias de materiais:', error);
      throw error;
    }
  },

  // Listar opções de uma categoria
  getOpcoesByCategoria: async (categoriaId, params = {}) => {
    try {
      const response = await api.get(`/material-catalog/categorias-materiais/${categoriaId}/opcoes`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar opções da categoria:', error);
      throw error;
    }
  },

  // Buscar materiais de apresentação de um levantamento
  getMateriaisApresentacao: async (surveyId, params = {}) => {
    try {
      const response = await api.get(`/material-catalog/materiais-apresentacao/${surveyId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar materiais de apresentação:', error);
      throw error;
    }
  },

  // Salvar material de apresentação
  saveMateriaisApresentacao: async (surveyId, data) => {
    try {
      const response = await api.post(`/material-catalog/materiais-apresentacao/${surveyId}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar material de apresentação:', error);
      throw error;
    }
  },

  // Deletar material de apresentação
  deleteMateriaisApresentacao: async (id) => {
    try {
      const response = await api.delete(`/material-catalog/materiais-apresentacao/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar material de apresentação:', error);
      throw error;
    }
  },

  // Listar produtos disponíveis para apresentação
  getProdutosApresentacao: async (params = {}) => {
    try {
      const response = await api.get('/material-catalog/produtos-apresentacao', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar produtos para apresentação:', error);
      throw error;
    }
  }
};

export default materialCatalogService;
